export class DisbilityOfStudent{
    id : number;

    typeOfDisabilityId : number;
    typeOfDisabilityName : string;

    studentId : number; 

    levelId : number;
    levelName : string;

    note : string;
} 